export default __webpack_public_path__ + "static/media/brand-image-02.b55ee760.jpg";